import { IconExpandMore } from "@/assets/icons";
import { InnerBox } from "@/modules/irohana-components/elements/InnerBox/InnerBox";
import { icon, text } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Collapse, IconButton, Typography, styled } from "@mui/material";
import { useState } from "react";

type TCompanySectionCardProps = {
  title: string;
  /** Every section starts expanded, as drawn in the Figma capture. */
  defaultExpanded?: boolean;
};

/** Section card of ACC20C02: bold title with a collapse toggle on the right. */
export const CompanySectionCard: FCC<TCompanySectionCardProps> = ({ title, defaultExpanded = true, children }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <InnerBox
      padding="24px"
      gap="16px"
      title={
        <Typography variant="sub16Bold" color={text.primary}>
          {title}
        </Typography>
      }
      rightContent={
        <ToggleButton
          size="small"
          onClick={() => setExpanded((current) => !current)}
          aria-label={`${title}の${expanded ? "折りたたみ" : "展開"}`}
          aria-expanded={expanded}
        >
          <ToggleIcon expanded={expanded} />
        </ToggleButton>
      }
    >
      <Collapse in={expanded} unmountOnExit={false}>
        {children}
      </Collapse>
    </InnerBox>
  );
};

const ToggleButton = styled(IconButton)`
  padding: 4px;
  svg {
    font-size: 24px;
  }
`;

const ToggleIcon = styled(IconExpandMore, { shouldForwardProp: (prop) => prop !== "expanded" })<{ expanded: boolean }>`
  color: ${icon.default};
  transition: transform 0.2s ease;
  transform: rotate(${({ expanded }) => (expanded ? "180deg" : "0deg")});
`;
